import type { MapStyleAuthoringPaneProps } from "../../contracts/map-workspace";
import { cn } from "../../lib/utils";
import { MapStyleLayersPane } from "./MapStyleLayersPane";
import { MapStyleRenderStackEditor } from "./MapStyleRenderStackEditor";

/**
 * MapStyleAuthoringPane
 * Render-stack-native style authoring workspace that switches between inventory and entry editing.
 * Acts as a pure presentational adapter that translates the existing editor prop
 * into inline editor content for the MapStyleLayersPane.
 */
export function MapStyleAuthoringPane({
  editor,
  className,
  ...layersPaneProps
}: MapStyleAuthoringPaneProps) {
  // Translate the editor prop into inline editor body content
  const editorContent = editor ? <MapStyleRenderStackEditor {...editor} /> : null;

  return (
    <div className={cn("flex min-h-0 h-full flex-col", className)}>
      <MapStyleLayersPane {...layersPaneProps} editorContent={editorContent} />
    </div>
  );
}
